import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      "nav.viewReports": "View reports",
      "nav.dashboard": "Dashboard",
      "nav.reportIssue": "Report Issue",
      "nav.login": "Login / Register",
      "nav.logout": "Logout",
      "nav.backHome": "Back to Home",
      "nav.backReports": "Back to Reports",
      "nav.backDashboard": "Back to Dashboard",
      "nav.about": "Who we are",
      "nav.moderator": "Moderator",
      "nav.admin": "Admin",

      // Home Page
      "home.title": "Fix India,",
      "home.subtitle": "One Issue at a Time",
      "home.description": "Report public issues, crowdfund solutions, and track progress transparently. Join thousands of citizens making a real difference.",
      "home.getStarted": "Get Started",
      "home.browseIssues": "Browse Issues",
      "home.totalReports": "Total Reports",
      "home.resolved": "Resolved",
      "home.active": "Active",
      "home.raised": "Raised",
      "home.reportAnyIssue": "Report Any Issue",
      "home.reportAnyIssueDesc": "From potholes to power outages, we handle it all",
      "home.howItWorks": "How It Works",
      "home.howItWorksDesc": "Simple, transparent, and effective",
      "home.step1": "Report Issue",
      "home.step1Desc": "Upload photos, add location, and describe the problem in your community",
      "home.step2": "Verification",
      "home.step2Desc": "Our team verifies and estimates the cost for resolution",
      "home.step3": "Crowdfund & Fix",
      "home.step3Desc": "Community contributes, we execute, and you track every step",
      "home.ctaTitle": "Ready to Make a Difference?",
      "home.ctaDesc": "Join thousands of citizens creating real change in their communities",
      "home.startReporting": "Start Reporting Now",
      "home.footer": "Making India better, one issue at a time.",
      "home.reportAnyIssue.en": "Report Any Issue",
      "home.reportAnyIssueDesc.en": "From potholes to power outages, we handle it all",



      // Categories
      "category.pothole": "Pothole",
      "category.pothole.desc": "Road damage",
      "category.road": "Road",
      "category.road.desc": "Infrastructure",
      "category.water": "Water",
      "category.water.desc": "Water supply",
      "category.electricity": "Electricity",
      "category.electricity.desc": "Power issues",
      "category.garbage": "Garbage",
      "category.garbage.desc": "Sanitation",
      "category.safety": "Safety",
      "category.safety.desc": "Public safety",
      "category.general": "General",

      // Reports List
      "reports.title": "All Reports",
      "reports.issuesReported": "issues reported",
      "reports.reportNew": "Report New Issue",
      "reports.createNew": "Create Your First Report",
      "reports.noReports": "No reports found",
      "reports.loading": "Loading reports...",

      // Filters
      "filter.allCategories": "All Categories",
      "filter.allStatus": "All Status",
      "filter.allLocations": "All Locations",
      "filter.searchLocation": "Search Location",
      "filter.locationPlaceholder": "Search by Plus Code (J9Q6+97) or Coordinates (28.6139, 77.2090)",
      "filter.locationHint": "Search reports within 100 meters. Formats supported:",
      "filter.coordinates": "Coordinates",
      "filter.plusCode": "Plus Code with location",
      "filter.fullPlusCode": "Full Plus Code",
      "filter.showingNear": "Showing results near:",
      "filter.clearSearch": "Clear search",

      // Report Form (State/City)
      "reportForm.state": "State",
      "reportForm.city": "City",
      "reportForm.selectState": "Select State",
      "reportForm.selectCity": "Select City",
      "reportForm.selectStateFirst": "Select State First",
      // Status
      "status.submitted": "Submitted",
      "status.under_review": "Under Review",
      "status.verified": "Verified",
      "status.fundraising": "Fundraising",
      "status.in_progress": "In Progress",
      "status.completed": "Completed",

      // Report Detail
      "report.openMap": "Open in Google Maps",
      "report.viewMap": "View Map",
      "report.urgency": "Priority",
      "report.underReview": "Under Review",
      "report.underReviewDesc": "This report is being verified by our team. Estimated cost will be available soon.",
      "report.fundingProgress": "Funding Progress",
      "report.of": "of",
      "report.funded": "funded",
      "report.supporters": "Supporters",
      "report.deadline": "Deadline",
      "report.supportCause": "Support This Cause",
      "report.platformFee": "Platform adds 10% operational fee to the target amount.",
      "report.expenses": "Expenses Breakdown",
      "report.total": "Total",
      "report.verification": "Verification Comments",

      // Comments
      "comments.title": "Comments",
      "comments.placeholder": "Share your thoughts...",
      "comments.post": "Post Comment",
      "comments.loginRequired": "Please login to post comments",
      "comments.noComments": "No comments yet. Be the first to comment!",
      "comments.delete": "Delete",

      // Donation
      "donate.title": "Support This Cause",
      "donate.amount": "Donation Amount (₹)",
      "donate.amountPlaceholder": "Enter amount (min ₹100)",
      "donate.message": "Your contribution will help fix this issue. All transactions are processed securely through Razorpay.",
      "donate.now": "Donate Now",
      "donate.processing": "Processing...",
      "donate.cancel": "Cancel",
      "donate.minAmount": "Minimum donation is ₹100",

      // Auth
      "auth.login": "Login",
      "auth.register": "Register",
      "auth.loginWithPhone": "Login with Phone",
      "auth.phoneNumber": "Phone Number",
      "auth.phonePlaceholder": "Enter 10-digit number",
      "auth.enterOTP": "Enter OTP",
      "auth.otpPlaceholder": "6-digit OTP",
      "auth.otpSent": "OTP sent to",
      "auth.sendOTP": "Send OTP",
      "auth.verifyOTP": "Verify OTP",
      "auth.changeNumber": "Change Number",
      "auth.name": "Name",
      "auth.namePlaceholder": "Your full name",
      "auth.city": "City",
      "auth.cityPlaceholder": "Your city",
      "auth.completeReg": "Complete Registration",
      "auth.dontHaveAccount": "Don't have an account?",
      "auth.haveAccount": "Already have an account?",

      // Dashboard
      "dashboard.welcome": "Welcome,",
      "dashboard.myReports": "My Reports",
      "dashboard.donations": "Donations Made",
      "dashboard.totalContributed": "Total Contributed",
      "dashboard.myReportsTab": "My Reports",
      "dashboard.myDonationsTab": "My Donations",
      "dashboard.noReports": "You haven't reported any issues yet",
      "dashboard.noDonations": "You haven't made any donations yet",
      "dashboard.browseReports": "Browse Reports to Support",
      "dashboard.createViaHeaderPlus": "Use the + icon next to “View Reports” in the header to create a report",
      

      // Support
      "support.title": "Support Tickets",
      "support.desc": "Get help with refunds, issues, or general queries",
      "support.newTicket": "New Ticket",
      "support.createTicket": "Create Support Ticket",
      "support.ticketType": "Ticket Type",
      "support.selectType": "Select type",
      "support.refund": "Refund Request",
      "support.dispute": "Payment Dispute",
      "support.general": "General Support",
      "support.bug": "Bug Report",
      "support.content": "Content Issue",
      "support.relatedId": "Related Report/Donation ID (Optional)",
      "support.relatedIdPlaceholder": "Enter report or donation ID",
      "support.description": "Description",
      "support.descPlaceholder": "Describe your issue in detail",
      "support.submit": "Create Ticket",
      "support.creating": "Creating...",
      "support.noTickets": "No support tickets yet",
      "support.createFirst": "Create Your First Ticket",
      "support.relatedTo": "Related to:",

      // Report Form
      "reportForm.title": "Report an Issue",
      "reportForm.desc": "Help us make your community better",
      "reportForm.titleLabel": "Title",
      "reportForm.titlePlaceholder": "Brief description of the issue",
      "reportForm.category": "Category",
      "reportForm.selectCategory": "Select category",
      "reportForm.description": "Description",
      "reportForm.descPlaceholder": "Provide detailed information about the issue",
      "reportForm.urgency": "Urgency",
      "reportForm.low": "Low",
      "reportForm.normal": "Normal",
      "reportForm.high": "High",
      "reportForm.critical": "Critical",
      "reportForm.location": "Location",
      "reportForm.locationPlaceholder": "Enter location or use current location",
      "reportForm.detectLocation": "Detect Location",
      "reportForm.coordinates": "Coordinates",
      "reportForm.photos": "Photos",
      "reportForm.uploadPhotos": "Click to upload photos",
      "reportForm.photoFormat": "PNG, JPG up to 10MB",
      "reportForm.submitReport": "Submit Report",
      "reportForm.submitting": "Submitting...",

      // Messages
      "msg.success": "Success",
      "msg.error": "Error",
      "msg.loginSuccess": "Login successful!",
      "msg.regSuccess": "Registration successful!",
      "msg.reportSubmitted": "Report submitted successfully!",
      "msg.commentAdded": "Comment added",
      "msg.commentDeleted": "Comment deleted",
      "msg.donationSuccess": "Donation successful! Thank you for your contribution.",
      "msg.ticketCreated": "Support ticket created successfully",
      "msg.locationDetected": "Location detected",
      "msg.pleaseLogin": "Please login to continue",

      // Moderator Dashboard
      "mod.dashboard": "Moderator Dashboard",
      "mod.welcome": "Welcome, Moderator",
      "mod.pendingReports": "Pending Reports",
      "mod.pendingRefunds": "Pending Refunds",
      "mod.flaggedComments": "Flagged Comments",
      "mod.fraudAlerts": "Fraud Alerts",
      "mod.pendingReportsTab": "Pending Reports",
      "mod.refundsTab": "Refund Requests",
      "mod.commentsTab": "Flagged Comments",
      "mod.fraudTab": "Fraud Alerts",
      "mod.noPendingReports": "No pending reports",
      "mod.noRefundRequests": "No refund requests",
      "mod.noFlaggedComments": "No flagged comments",
      "mod.noFraudAlerts": "No fraud alerts",
      "mod.approveReport": "Approve",
      "mod.rejectReport": "Reject",
      "mod.estimatedCost": "Estimated Cost (₹)",
      "mod.verificationComments": "Verification Comments",
      "mod.closeDate": "Close Date",
      "mod.approving": "Approving...",
      "mod.rejecting": "Rejecting...",
      "mod.processing": "Processing...",
      "mod.approveRefund": "Approve Refund",
      "mod.rejectRefund": "Reject Refund",
      "mod.moderatorComments": "Moderator Comments",
      "mod.removeComment": "Remove Comment",
      "mod.ignoreFlag": "Ignore Flag",
      "mod.reason": "Reason",
      "mod.flaggedBy": "Flagged by",
      "mod.commentText": "Comment",
      "mod.alertType": "Alert Type",
      "mod.severity": "Severity",
      "mod.details": "Details",
      "mod.markInvestigating": "Mark as Investigating",
      "mod.markResolved": "Mark as Resolved",
      "mod.markFalsePositive": "Mark as False Positive",
      "mod.donationCount": "Donation Count",
      "mod.reportCreator": "Report Creator",
      "mod.amount": "Amount",
      "mod.pattern": "Pattern",

      // Common
      "common.cancel": "Cancel",
      "common.save": "Save",
      "common.edit": "Edit",
      "common.delete": "Delete",
      "common.view": "View",
      "common.loading": "Loading...",
      "common.noData": "No data available",
      "common.search": "Search",
      "common.filter": "Filter",
      "common.progress": "Progress",
      "common.viewMap": "View Map",
      "common.backHome": "Back to Home",

      // Refund
      "refund.title": "Refund Request",
      "refund.eligible": "You are eligible for refund",
      "refund.notEligible": "Not eligible for refund",
      "refund.cooldown": "Refund available after 24 hours",
      "refund.above80": "Funding above 80% - requires approval",
      "refund.requestBtn": "Request Refund",
      "refund.reason": "Reason for refund",
      "refund.reasonPlaceholder": "Please explain why you need a refund",
      "refund.submit": "Submit Request",

      // Work Execution
      "work.assignVendor": "Assign Vendor",
      "work.vendorName": "Vendor Name",
      "work.vendorContact": "Vendor Contact",
      "work.vendorEmail": "Vendor Email (Optional)",
      "work.showPublicly": "Show vendor details publicly",
      "work.workStartDate": "Work Start Date",
      "work.assign": "Assign",
      "work.addUpdate": "Add Work Update",
      "work.updateDescription": "Update Description",
      "work.uploadPhotos": "Upload Progress Photos",
      "work.status": "Work Status",
      "work.started": "Started",
      "work.inProgress": "In Progress",
      "work.completed": "Completed",
      "work.addUpdateBtn": "Add Update",
      "work.completeWork": "Complete Work",
      "work.finalPhotos": "Final Completion Photos",
      "work.completionNotes": "Completion Notes",
      "work.markComplete": "Mark as Complete",
      "work.timeline": "Work Timeline",
      "work.noUpdates": "No work updates yet",
      "work.vendorDetails": "Vendor Details",
      "work.assignedOn": "Assigned On",
      "work.workProgress": "Work Progress",
      
      // About / AboutUs page
      "about.hero.eyebrow": "Who we are",
      "about.hero.title.part1": "Citizens fixing India,",
      "about.hero.title.part2": " one issue at a time.",
      "about.hero.description": "FixOurIndia is a citizen-led platform to report local problems, track public responses and crowdfund solutions. We help people move from complaining to creating change.",
      "about.mission.title": "Our mission",
      "about.mission.p1": "Everyday issues like potholes, garbage dumps and broken streetlights can stay unresolved for months. They impact safety, health and dignity — but they rarely make it into formal systems.",
      "about.mission.p2": "Our mission is to give every citizen a simple way to raise issues, mobilise support and see visible action. We connect residents, RWAs, NGOs, media and authorities on one transparent platform where everyone can see what’s happening.",
      "about.story.title": "Our story",
      "about.story.p1": "FixOurIndia began as a response to a reality many citizens silently endure: complaints that disappear, officials who don’t respond, and a system where progress often depends on who you know — or worse, what you can pay.",
      "about.story.p2": "We witnessed people being asked for bribes for basic services, delayed fixes due to internal miscommunication, and communities left confused about whether anyone was actually working on their issue. These experiences made one thing clear: the problem wasn’t only in infrastructure — it was in transparency, accountability and trust.",
      "about.story.p3": "That’s why we built FixOurIndia: a platform where issues can no longer be hidden, ignored or manipulated. Residents report openly, authorities respond visibly, and communities watch progress in real time — without middlemen, without bribes and without confusion.",
      "about.story.builtBy": "Built by",
      "about.story.builtBy.value": "Common citizens",
      "about.story.focus": "Focus",
      "about.story.focus.value": "Local civic problems",
      "about.story.approach": "Approach",
      "about.story.approach.value": "Transparency + technology",
      "about.story.vision": "Vision",
      "about.story.vision.value": "Zero corruption, complete visibility",

      "about.howWeHelp.title": "How we help on the ground", 
      "about.howWeHelp.subtitle": "From the first photo of a broken road to the final “fixed” update, FixOurIndia is designed to guide every step of the journey.",
      "about.howWeHelp.items.1.eyebrow": "01 · Report",
      "about.howWeHelp.items.1.title": "Capture the issue clearly",
      "about.howWeHelp.items.1.description": "Upload photos, add location and describe the problem in a few lines. No complicated forms, just what’s needed to act.",
      "about.howWeHelp.items.2.eyebrow": "02 · Coordinate",
      "about.howWeHelp.items.2.title": "Bring the right people in",
      "about.howWeHelp.items.2.description": "Residents, volunteers and partners collaborate through a shared timeline with updates, tasks and milestones.",
      "about.howWeHelp.items.3.eyebrow": "03 · Fix & follow up",
      "about.howWeHelp.items.3.title": "Track progress transparently",
      "about.howWeHelp.items.3.description": "From verification to funding to completion, every step is logged so the community can see exactly what changed.",

      "about.values.title": "What we stand for",
      "about.values.subtitle": "These principles guide our features, partnerships and the way we measure success.",

      "about.values.transparency.title": "Complete transparency",
      "about.values.transparency.description": "Every report, rupee and update is visible to the community, so nothing happens behind closed doors.",
      "about.values.accountability.title": "Strong accountability",
      "about.values.accountability.description": "Clear owners, timelines and an auditable history make it harder for issues to quietly disappear.",
      "about.values.anticorruption.title": "Zero tolerance for corruption",
      "about.values.anticorruption.description": "No middlemen, no under-the-table favours. A digital trail and open communication reduce scope for misuse.",
      "about.values.quality.title": "Quality & reliability",
      "about.values.quality.description": "Accurate data, verified updates and a robust platform that communities and partners can trust for the long term.",

      "about.cta.title": "Ready to join us?",
      "about.cta.description": "Start by reporting one issue in your area or supporting an existing one. Small steps, big change.",
      "about.faq.title": "Frequently asked questions",
      "about.faq.subtitle": "Quick answers to how FixOurIndia works behind the scenes.",
      "about.faq.searchPlaceholder": "Search questions or keywords...",
      "about.faq.noResults": "No questions found for this search. Try a different keyword.",

      // FAQ Q&A
      "about.faq.q1.question": "How does FixOurIndia operate on a reported problem?",
      "about.faq.q1.answer": "• A citizen reports an issue with photos, location, and a short description.\n• Our team verifies the report to ensure it is genuine and actionable.\n• We speak to local contacts when needed to understand the situation better.\n• We collect realistic estimates from vendors for repair or restoration work.\n• After verification and costing, the issue is moved forward for funding and execution.",

      "about.faq.q2.question": "How do donations and refunds work?",
      "about.faq.q2.answer": "Donations are accepted only for verified issues, ensuring trust and transparency. Donors can download their receipts directly from the receipts screen.\n\nRefund Guidelines:\n• Platform charges apply when processing refunds — we only pass the actual payment gateway fee with no extra cost added.\n• No refunds are allowed once repair work is in progress or has been completed.\n• If more than 80% of the required amount is collected, refund requests go through a moderator review to prevent disruption to ongoing work.\n• If 100% of the amount is not collected within 12 months, the entire donated amount is refunded back to all donors.",

      "about.faq.q3.question": "How can I join FixOurIndia?",
      "about.faq.q3.answer": "We’re not actively expanding our team at the moment, but we’re always happy to connect with passionate citizens. You can share your details at: abxemailid@example.com",

      "about.faq.q4.question": "How can I report an issue?",
      "about.faq.q4.answer": "Reporting is currently supported in select cities. Expansion to more cities may happen based on user inputs, community interest, and overall donation activity.",

      "about.faq.q5.question": "How do you ensure high-quality fixes?",
      "about.faq.q5.answer": "We rely on modern technology, verified local contractors and a transparent workflow.\nQuality is checked at every stage through photos, estimates and community feedback.\nAfter completion, each fix stays visible on the platform for at least a year to ensure it holds up over time.",

      "about.faq.q6.question": "How is the work executed and monitored?",
      "about.faq.q6.answer": "• A repair date is scheduled after funds are confirmed.\n• Contractors upload photo updates during the work.\n• After completion, the fix is monitored for 12 months.\n• Monthly photos are posted so the community can verify ongoing quality.",

      "about.faq.q7.question": "How do you ensure there is no corruption?",
      "about.faq.q7.answer": "• Every issue shows a full expense breakdown before donations open.\n• Costs are based on verified vendor estimates — nothing hidden.\n• No bribes, no under-the-table payments, no middlemen.\n• FixOurIndia never pays anyone outside the approved workflow.\n• All transactions and updates are public, ensuring complete transparency.",

      "about.faq.q8.question": "Why does my refund differ slightly from the amount I donated?",
      "about.faq.q8.answer": "FixOurIndia always releases the full refund from our side.\n• Any difference you see comes only from Razorpay’s non-refundable transaction fees — a standard industry policy we cannot override.\n• We highlight the final refund amount in advance so there are no surprises.\n• Our commitment is simple: complete honesty, no hidden cuts, and no silent deductions from our end.",

      "about.faq.q9.question": "When do you stop accepting donations for an issue?",
      "about.faq.q9.answer": "We stop taking donations as soon as it is no longer responsible or necessary to collect more money.\nWe close a campaign when:\n• The issue reaches 100% of the required amount.\n• Repair work has already started and no additional funds are needed.\n• The issue becomes invalid (already fixed, blocked by authorities, unsafe, or no longer relevant).\n• A year passes without reaching the target and the community decides not to continue.\n• Our team finds verification problems or something that needs rechecking.\nFixOurIndia never keeps fundraising open unnecessarily — we only take what is genuinely required to complete the fix." 
    }
  },
  hi: {
    translation: {
      // Navigation
      "nav.viewReports": "रिपोर्ट देखें",
      "nav.dashboard": "डैशबोर्ड",
      "nav.reportIssue": "समस्या रिपोर्ट करें",
      "nav.login": "लॉगिन / रजिस्टर",
      "nav.logout": "लॉगआउट",
      "nav.backHome": "होम पर वापस जाएं",
      "nav.backReports": "रिपोर्ट पर वापस जाएं",
      "nav.backDashboard": "डैशबोर्ड पर वापस जाएं",
      "nav.about": "हम कौन हैं",
      "nav.moderator": "मॉडरेटर",
      "nav.admin": "एडमिन",

      // Home Page
      "home.title": "भारत को ठीक करें,",
      "home.subtitle": "एक समस्या एक बार में",
      "home.description": "सार्वजनिक समस्याओं की रिपोर्ट करें, समाधान के लिए क्राउडफंड करें, और पारदर्शी रूप से प्रगति ट्रैक करें। हजारों नागरिकों के साथ जुड़ें जो वास्तविक बदलाव ला रहे हैं।",
      "home.getStarted": "शुरू करें",
      "home.browseIssues": "समस्याएं ब्राउज़ करें",
      "home.totalReports": "कुल रिपोर्ट",
      "home.resolved": "हल हुए",
      "home.active": "सक्रिय",
      "home.raised": "जुटाया गया",
      "home.reportAnyIssue": "कोई भी समस्या रिपोर्ट करें",
      "home.reportAnyIssueDesc": "गड्ढों से लेकर बिजली कटौती तक, हम सब संभालते हैं",
      "home.howItWorks": "यह कैसे काम करता है",
      "home.howItWorksDesc": "सरल, पारदर्शी और प्रभावी",
      "home.step1": "समस्या रिपोर्ट करें",
      "home.step1Desc": "फोटो अपलोड करें, स्थान जोड़ें, और अपने समुदाय में समस्या का वर्णन करें",
      "home.step2": "सत्यापन",
      "home.step2Desc": "हमारी टीम सत्यापित करती है और समाधान की लागत का अनुमान लगाती है",
      "home.step3": "क्राउडफंड और ठीक करें",
      "home.step3Desc": "समुदाय योगदान देता है, हम निष्पादित करते हैं, और आप हर कदम को ट्रैक करते हैं",
      "home.ctaTitle": "बदलाव लाने के लिए तैयार हैं?",
      "home.ctaDesc": "हजारों नागरिकों के साथ जुड़ें जो अपने समुदायों में वास्तविक बदलाव ला रहे हैं",
      "home.startReporting": "अभी रिपोर्ट करना शुरू करें",
      "home.footer": "भारत को बेहतर बना रहे हैं, एक समस्या एक बार में।",
      "home.reportAnyIssue.hi": "कोई भी समस्या रिपोर्ट करें",
      "home.reportAnyIssueDesc.hi": "गड्ढों से लेकर बिजली कटौती तक, हम सब संभालते हैं",

      // Categories
      "category.pothole": "गड्ढा",
      "category.pothole.desc": "सड़क की क्षति",
      "category.road": "सड़क",
      "category.road.desc": "बुनियादी ढांचा",
      "category.water": "पानी",
      "category.water.desc": "पानी की आपूर्ति",
      "category.electricity": "बिजली",
      "category.electricity.desc": "बिजली की समस्याएं",
      "category.garbage": "कचरा",
      "category.garbage.desc": "स्वच्छता",
      "category.safety": "सुरक्षा",
      "category.safety.desc": "सार्वजनिक सुरक्षा",
      "category.general": "सामान्य",

      // Reports List
      "reports.title": "सभी रिपोर्ट",
      "reports.issuesReported": "समस्याएं रिपोर्ट की गई",
      "reports.reportNew": "नई समस्या रिपोर्ट करें",
      "reports.createNew": "अपनी पहली रिपोर्ट बनाएं",
      "reports.noReports": "कोई रिपोर्ट नहीं मिली",
      "reports.loading": "रिपोर्ट लोड हो रही हैं...",

      // Report Form (State/City)
      "reportForm.state": "राज्य",
      "reportForm.city": "शहर",
      "reportForm.selectState": "राज्य चुनें",
      "reportForm.selectCity": "शहर चुनें",
      "reportForm.selectStateFirst": "पहले राज्य चुनें",

      // Filters
      "filter.allCategories": "सभी श्रेणियां",
      "filter.allStatus": "सभी स्थिति",
      "filter.allLocations": "सभी स्थान",
      "filter.searchLocation": "स्थान खोजें",
      "filter.locationPlaceholder": "प्लस कोड (J9Q6+97) या निर्देशांक (28.6139, 77.2090) द्वारा खोजें",
      "filter.locationHint": "100 मीटर के भीतर रिपोर्ट खोजें। समर्थित प्रारूप:",
      "filter.coordinates": "निर्देशांक",
      "filter.plusCode": "स्थान के साथ प्लस कोड",
      "filter.fullPlusCode": "पूर्ण प्लस कोड",
      "filter.showingNear": "निकट परिणाम दिखा रहे हैं:",
      "filter.clearSearch": "खोज साफ़ करें",

      // Status
      "status.submitted": "सबमिट किया गया",
      "status.under_review": "समीक्षाधीन",
      "status.verified": "सत्यापित",
      "status.fundraising": "फंड जुटाया जा रहा है",
      "status.in_progress": "प्रगति में",
      "status.completed": "पूर्ण",

      // Report Detail
      "report.openMap": "Google Maps में खोलें",
      "report.viewMap": "मानचित्र देखें",
      "report.urgency": "प्राथमिकता",
      "report.underReview": "समीक्षाधीन",
      "report.underReviewDesc": "यह रिपोर्ट हमारी टीम द्वारा सत्यापित की जा रही है। अनुमानित लागत जल्द ही उपलब्ध होगी।",
      "report.fundingProgress": "फंडिंग प्रगति",
      "report.of": "का",
      "report.funded": "फंड किया गया",
      "report.supporters": "समर्थक",
      "report.deadline": "समय सीमा",
      "report.supportCause": "इस कारण का समर्थन करें",
      "report.platformFee": "प्लेटफ़ॉर्म लक्षित राशि पर 10% परिचालन शुल्क जोड़ता है।",
      "report.expenses": "खर्चों का विवरण",
      "report.total": "कुल",
      "report.verification": "सत्यापन टिप्पणियां",

      // Comments
      "comments.title": "टिप्पणियां",
      "comments.placeholder": "अपने विचार साझा करें...",
      "comments.post": "टिप्पणी पोस्ट करें",
      "comments.loginRequired": "टिप्पणी पोस्ट करने के लिए कृपया लॉगिन करें",
      "comments.noComments": "अभी तक कोई टिप्पणी नहीं। पहले टिप्पणी करें!",
      "comments.delete": "हटाएं",

      // Donation
      "donate.title": "इस कारण का समर्थन करें",
      "donate.amount": "दान राशि (₹)",
      "donate.amountPlaceholder": "राशि दर्ज करें (न्यूनतम ₹100)",
      "donate.message": "आपका योगदान इस समस्या को ठीक करने में मदद करेगा। सभी लेनदेन Razorpay के माध्यम से सुरक्षित रूप से संसाधित किए जाते हैं।",
      "donate.now": "अभी दान करें",
      "donate.processing": "प्रोसेस हो रहा है...",
      "donate.cancel": "रद्द करें",
      "donate.minAmount": "न्यूनतम दान ₹100 है",

      // Auth
      "auth.login": "लॉगिन",
      "auth.register": "रजिस्टर",
      "auth.loginWithPhone": "फोन से लॉगिन करें",
      "auth.phoneNumber": "फोन नंबर",
      "auth.phonePlaceholder": "10 अंकों का नंबर दर्ज करें",
      "auth.enterOTP": "OTP दर्ज करें",
      "auth.otpPlaceholder": "6 अंकों का OTP",
      "auth.otpSent": "OTP भेजा गया",
      "auth.sendOTP": "OTP भेजें",
      "auth.verifyOTP": "OTP सत्यापित करें",
      "auth.changeNumber": "नंबर बदलें",
      "auth.name": "नाम",
      "auth.namePlaceholder": "आपका पूरा नाम",
      "auth.city": "शहर",
      "auth.cityPlaceholder": "आपका शहर",
      "auth.completeReg": "रजिस्ट्रेशन पूरा करें",
      "auth.dontHaveAccount": "खाता नहीं है?",
      "auth.haveAccount": "पहले से खाता है?",

      // Dashboard
      "dashboard.welcome": "स्वागत है,",
      "dashboard.myReports": "मेरी रिपोर्ट",
      "dashboard.donations": "किए गए दान",
      "dashboard.totalContributed": "कुल योगदान",
      "dashboard.myReportsTab": "मेरी रिपोर्ट",
      "dashboard.myDonationsTab": "मेरे दान",
      "dashboard.noReports": "आपने अभी तक कोई समस्या रिपोर्ट नहीं की है",
      "dashboard.noDonations": "आपने अभी तक कोई दान नहीं किया है",
      "dashboard.browseReports": "समर्थन के लिए रिपोर्ट ब्राउज़ करें",
      "dashboard.createViaHeaderPlus": "रिपोर्ट बनाने के लिए हेडर में “रिपोर्ट देखें” के पास + आइकन का उपयोग करें",


      // Support
      "support.title": "सहायता टिकट",
      "support.desc": "रिफंड, समस्याओं या सामान्य प्रश्नों के लिए सहायता प्राप्त करें",
      "support.newTicket": "नया टिकट",
      "support.createTicket": "सहायता टिकट बनाएं",
      "support.ticketType": "टिकट प्रकार",
      "support.selectType": "प्रकार चुनें",
      "support.refund": "रिफंड अनुरोध",
      "support.dispute": "भुगतान विवाद",
      "support.general": "सामान्य सहायता",
      "support.bug": "बग रिपोर्ट",
      "support.content": "सामग्री समस्या",
      "support.relatedId": "संबंधित रिपोर्ट/दान ID (वैकल्पिक)",
      "support.relatedIdPlaceholder": "रिपोर्ट या दान ID दर्ज करें",
      "support.description": "विवरण",
      "support.descPlaceholder": "अपनी समस्या का विस्तार से वर्णन करें",
      "support.submit": "टिकट बनाएं",
      "support.creating": "बनाया जा रहा है...",
      "support.noTickets": "अभी तक कोई सहायता टिकट नहीं",
      "support.createFirst": "अपना पहला टिकट बनाएं",
      "support.relatedTo": "संबंधित:",

      // Report Form
      "reportForm.title": "समस्या रिपोर्ट करें",
      "reportForm.desc": "अपने समुदाय को बेहतर बनाने में हमारी मदद करें",
      "reportForm.titleLabel": "शीर्षक",
      "reportForm.titlePlaceholder": "समस्या का संक्षिप्त विवरण",
      "reportForm.category": "श्रेणी",
      "reportForm.selectCategory": "श्रेणी चुनें",
      "reportForm.description": "विवरण",
      "reportForm.descPlaceholder": "समस्या के बारे में विस्तृत जानकारी प्रदान करें",
      "reportForm.urgency": "तात्कालिकता",
      "reportForm.low": "कम",
      "reportForm.normal": "सामान्य",
      "reportForm.high": "उच्च",
      "reportForm.critical": "गंभीर",
      "reportForm.location": "स्थान",
      "reportForm.locationPlaceholder": "स्थान दर्ज करें या वर्तमान स्थान का उपयोग करें",
      "reportForm.detectLocation": "स्थान का पता लगाएं",
      "reportForm.coordinates": "निर्देशांक",
      "reportForm.photos": "फोटो",
      "reportForm.uploadPhotos": "फोटो अपलोड करने के लिए क्लिक करें",
      "reportForm.photoFormat": "PNG, JPG 10MB तक",
      "reportForm.submitReport": "रिपोर्ट सबमिट करें",
      "reportForm.submitting": "सबमिट हो रहा है...",

      // Messages
      "msg.success": "सफलता",
      "msg.error": "त्रुटि",
      "msg.loginSuccess": "लॉगिन सफल!",
      "msg.regSuccess": "रजिस्ट्रेशन सफल!",
      "msg.reportSubmitted": "रिपोर्ट सफलतापूर्वक सबमिट की गई!",
      "msg.commentAdded": "टिप्पणी जोड़ी गई",
      "msg.commentDeleted": "टिप्पणी हटाई गई",
      "msg.donationSuccess": "दान सफल! आपके योगदान के लिए धन्यवाद।",
      "msg.ticketCreated": "सहायता टिकट सफलतापूर्वक बनाया गया",
      "msg.locationDetected": "स्थान का पता लगाया गया",
      "msg.pleaseLogin": "जारी रखने के लिए कृपया लॉगिन करें",

      // Moderator Dashboard
      "mod.dashboard": "मॉडरेटर डैशबोर्ड",
      "mod.welcome": "स्वागत है, मॉडरेटर",
      "mod.pendingReports": "लंबित रिपोर्ट",
      "mod.pendingRefunds": "लंबित रिफंड",
      "mod.flaggedComments": "फ्लैग की गई टिप्पणियां",
      "mod.fraudAlerts": "धोखाधड़ी अलर्ट",
      "mod.pendingReportsTab": "लंबित रिपोर्ट",
      "mod.refundsTab": "रिफंड अनुरोध",
      "mod.commentsTab": "फ्लैग की गई टिप्पणियां",
      "mod.fraudTab": "धोखाधड़ी अलर्ट",
      "mod.noPendingReports": "कोई लंबित रिपोर्ट नहीं",
      "mod.noRefundRequests": "कोई रिफंड अनुरोध नहीं",
      "mod.noFlaggedComments": "कोई फ्लैग की गई टिप्पणियां नहीं",
      "mod.noFraudAlerts": "कोई धोखाधड़ी अलर्ट नहीं",
      "mod.approveReport": "अनुमोदित करें",
      "mod.rejectReport": "अस्वीकार करें",
      "mod.estimatedCost": "अनुमानित लागत (₹)",
      "mod.verificationComments": "सत्यापन टिप्पणियां",
      "mod.closeDate": "बंद होने की तारीख",
      "mod.approving": "अनुमोदन हो रहा है...",
      "mod.rejecting": "अस्वीकार हो रहा है...",
      "mod.processing": "प्रक्रिया हो रही है...",
      "mod.approveRefund": "रिफंड स्वीकृत करें",
      "mod.rejectRefund": "रिफंड अस्वीकार करें",
      "mod.moderatorComments": "मॉडरेटर टिप्पणियां",
      "mod.removeComment": "टिप्पणी हटाएं",
      "mod.ignoreFlag": "फ्लैग को अनदेखा करें",
      "mod.reason": "कारण",
      "mod.flaggedBy": "द्वारा फ्लैग किया गया",
      "mod.commentText": "टिप्पणी",
      "mod.alertType": "अलर्ट प्रकार",
      "mod.severity": "गंभीरता",
      "mod.details": "विवरण",
      "mod.markInvestigating": "जांच के रूप में चिह्नित करें",
      "mod.markResolved": "हल के रूप में चिह्नित करें",
      "mod.markFalsePositive": "गलत सकारात्मक के रूप में चिह्नित करें",
      "mod.donationCount": "दान संख्या",
      "mod.reportCreator": "रिपोर्ट निर्माता",
      "mod.amount": "राशि",
      "mod.pattern": "पैटर्न",

      // Common
      "common.cancel": "रद्द करें",
      "common.save": "सहेजें",
      "common.edit": "संपादित करें",
      "common.delete": "हटाएं",
      "common.view": "देखें",
      "common.loading": "लोड हो रहा है...",
      "common.noData": "कोई डेटा उपलब्ध नहीं",
      "common.search": "खोजें",
      "common.filter": "फ़िल्टर",
      "common.progress": "प्रगति",
      "common.viewMap": "मानचित्र देखें",
      "common.backHome": "होम पर वापस जाएं",

      // Refund
      "refund.title": "रिफंड अनुरोध",
      "refund.eligible": "आप रिफंड के लिए पात्र हैं",
      "refund.notEligible": "रिफंड के लिए पात्र नहीं",
      "refund.cooldown": "24 घंटे के बाद रिफंड उपलब्ध",
      "refund.above80": "फंडिंग 80% से ऊपर - अनुमोदन की आवश्यकता",
      "refund.requestBtn": "रिफंड का अनुरोध करें",
      "refund.reason": "रिफंड का कारण",
      "refund.reasonPlaceholder": "कृपया बताएं कि आपको रिफंड की आवश्यकता क्यों है",
      "refund.submit": "अनुरोध सबमिट करें",

      // Work Execution
      "work.assignVendor": "विक्रेता असाइन करें",
      "work.vendorName": "विक्रेता का नाम",
      "work.vendorContact": "विक्रेता संपर्क",
      "work.vendorEmail": "विक्रेता ईमेल (वैकल्पिक)",
      "work.showPublicly": "विक्रेता विवरण सार्वजनिक रूप से दिखाएं",
      "work.workStartDate": "कार्य प्रारंभ तिथि",
      "work.assign": "असाइन करें",
      "work.addUpdate": "कार्य अपडेट जोड़ें",
      "work.updateDescription": "अपडेट विवरण",
      "work.uploadPhotos": "प्रगति फोटो अपलोड करें",
      "work.status": "कार्य स्थिति",
      "work.started": "शुरू",
      "work.inProgress": "प्रगति में",
      "work.completed": "पूर्ण",
      "work.addUpdateBtn": "अपडेट जोड़ें",
      "work.completeWork": "कार्य पूर्ण करें",
      "work.finalPhotos": "अंतिम पूर्णता फोटो",
      "work.completionNotes": "पूर्णता टिप्पणियां",
      "work.markComplete": "पूर्ण के रूप में चिह्नित करें",
      "work.timeline": "कार्य समयरेखा",
      "work.noUpdates": "अभी तक कोई कार्य अपडेट नहीं",
      "work.vendorDetails": "विक्रेता विवरण",
      "work.assignedOn": "असाइन किया गया",
      "work.workProgress": "कार्य प्रगति",

      // About / AboutUs page
     "about.hero.eyebrow": "हम कौन हैं",
     "about.hero.title.part1": "नागरिक मिलकर भारत को ठीक कर रहे हैं,",
     "about.hero.title.part2": " एक समस्या एक बार में।",
     "about.hero.description": "FixOurIndia एक नागरिक-चालित प्लेटफ़ॉर्म है जहाँ आप स्थानीय समस्याओं की रिपोर्ट कर सकते हैं, सार्वजनिक प्रतिक्रिया देख सकते हैं और समाधान के लिए क्राउडफंड कर सकते हैं। हमारा मकसद लोगों को सिर्फ शिकायत से आगे बढ़ाकर वास्तविक बदलाव की तरफ ले जाना है।",

    "about.mission.title": "हमारा मिशन",
    "about.mission.p1": "रोज़मर्रा की समस्याएं जैसे गड्ढे, कचरे के ढेर और खराब स्ट्रीटलाइटें महीनों तक अधूरी रह सकती हैं। ये सुरक्षा, स्वास्थ्य और गरिमा को प्रभावित करती हैं — लेकिन अक्सर औपचारिक सिस्टम तक पहुंच ही नहीं पातीं।",
    "about.mission.p2": "हमारा मिशन है कि हर नागरिक के पास एक सरल तरीका हो जिससे वह समस्याएं उठा सके, समर्थन जुटा सके और नतीजे देख सके। हम निवासी, RWA, NGO, मीडिया और अधिकारियों को एक पारदर्शी प्लेटफ़ॉर्म पर जोड़ते हैं जहाँ सब देख सकें कि क्या हो रहा है।",

    "about.story.title": "हमारी कहानी",
    "about.story.p1": "FixOurIndia की शुरुआत उस सच्चाई से हुई जिसे कई नागरिक चुपचाप सहते हैं: शिकायतें जो गायब हो जाती हैं, अधिकारी जो जवाब नहीं देते, और एक ऐसा सिस्टम जहाँ प्रगति अक्सर इस पर निर्भर करती है कि आप किसे जानते हैं — या बदतर, आप क्या चुका सकते हैं।",
    "about.story.p2": "हमने देखा कि लोगों से बुनियादी सेवाओं के लिए भी रिश्वत मांगी जाती है, अंदरूनी गड़बड़ियों के कारण काम टलते रहते हैं, और समुदायों को पता ही नहीं चलता कि उनकी समस्या पर कोई काम हो भी रहा है या नहीं। इससे साफ़ हुआ कि समस्या सिर्फ इंफ्रास्ट्रक्चर में नहीं, बल्कि पारदर्शिता, जवाबदेही और भरोसे में भी है।",
    "about.story.p3": "इसीलिए हमने FixOurIndia बनाया: एक ऐसा प्लेटफ़ॉर्म जहाँ समस्याओं को छिपाया, नज़रअंदाज़ या मनमर्जी से बदला नहीं जा सकता। निवासी खुले में रिपोर्ट करते हैं, अधिकारी सबके सामने जवाब देते हैं, और समुदाय रियल टाइम में प्रगति देख सकता है — बिना दलालों, बिना रिश्वत और बिना भ्रम के।",

    "about.story.builtBy": "निर्माता",
    "about.story.builtBy.value": "साधारण नागरिक",
    "about.story.focus": "फोकस",
    "about.story.focus.value": "स्थानीय नागरिक समस्याएं",
    "about.story.approach": "दृष्टिकोण",
    "about.story.approach.value": "पारदर्शिता + टेक्नोलॉजी",
    "about.story.vision": "विज़न",
    "about.story.vision.value": "शून्य भ्रष्टाचार, पूरी पारदर्शिता",

    "about.howWeHelp.title": "हम ज़मीनी स्तर पर कैसे मदद करते हैं",
    "about.howWeHelp.subtitle": "टूटी सड़क की पहली फोटो से लेकर अंतिम “ठीक हो गया” अपडेट तक, FixOurIndia हर कदम को गाइड करने के लिए बनाया गया है।",

    "about.howWeHelp.items.1.eyebrow": "01 · रिपोर्ट",
    "about.howWeHelp.items.1.title": "समस्या को साफ़-साफ़ दर्ज करें",
    "about.howWeHelp.items.1.description": "फोटो अपलोड करें, स्थान जोड़ें और कुछ लाइनों में समस्या का वर्णन करें। कोई जटिल फॉर्म नहीं — सिर्फ इतना जो कार्रवाई के लिए जरूरी है।",
    "about.howWeHelp.items.2.eyebrow": "02 · समन्वय",
    "about.howWeHelp.items.2.title": "सही लोगों को जोड़ें",
    "about.howWeHelp.items.2.description": "निवासी, स्वयंसेवक और पार्टनर एक साझा टाइमलाइन पर अपडेट, काम और माइलस्टोन के ज़रिए साथ काम करते हैं।",
    "about.howWeHelp.items.3.eyebrow": "03 · ठीक करें और फॉलो-अप",
    "about.howWeHelp.items.3.title": "प्रगति को पारदर्शी तरीके से ट्रैक करें",
    "about.howWeHelp.items.3.description": "सत्यापन से लेकर फंडिंग और काम पूरा होने तक हर कदम लॉग होता है, ताकि समुदाय साफ़ देख सके कि क्या बदला।",

    "about.values.title": "हम किन बातों पर खड़े हैं",
    "about.values.subtitle": "इन्हीं सिद्धांतों के आधार पर हम फीचर बनाते हैं, साझेदारी करते हैं और सफलता को मापते हैं।",

    "about.values.transparency.title": "पूरी पारदर्शिता",
    "about.values.transparency.description": "हर रिपोर्ट, हर रुपया और हर अपडेट समुदाय को दिखता है — ताकि पर्दे के पीछे कुछ न हो।",
    "about.values.accountability.title": "मजबूत जवाबदेही",
    "about.values.accountability.description": "साफ़ जिम्मेदार, समय-सीमा और रिकॉर्डेड इतिहास समस्याओं को चुपचाप गायब होना मुश्किल बनाते हैं।",
    "about.values.anticorruption.title": "भ्रष्टाचार के लिए ज़ीरो सहनशीलता",
    "about.values.anticorruption.description": "कोई बिचौलिया नहीं, कोई टेबल के नीचे की डील नहीं। डिजिटल ट्रेल और खुली बातचीत गलत इस्तेमाल की गुंजाइश कम करते हैं।",
    "about.values.quality.title": "गुणवत्ता और विश्वसनीयता",
    "about.values.quality.description": "सही डेटा, सत्यापित अपडेट और मज़बूत प्लेटफ़ॉर्म जिस पर समुदाय और पार्टनर लंबे समय तक भरोसा कर सकें।",

    "about.cta.title": "क्या आप हमारे साथ जुड़ने के लिए तैयार हैं?",
    "about.cta.description": "अपने आसपास की सिर्फ एक समस्या रिपोर्ट करके या किसी मौजूदा समस्या को सपोर्ट करके शुरू करें। छोटे कदम, बड़ा बदलाव।",

    "about.faq.title": "अक्सर पूछे जाने वाले प्रश्न",
    "about.faq.subtitle": "FixOurIndia अंदर से कैसे काम करता है, उसके कुछ त्वरित जवाब।",
    "about.faq.searchPlaceholder": "प्रश्न या कीवर्ड खोजें...",
    "about.faq.noResults": "इस खोज के लिए कोई प्रश्न नहीं मिला। कोई और कीवर्ड आज़माएं।",

    "about.faq.q1.question": "FixOurIndia रिपोर्ट की गई समस्या पर कैसे काम करता है?",
    "about.faq.q1.answer": "• कोई नागरिक फोटो, स्थान और छोटे से विवरण के साथ समस्या रिपोर्ट करता है।\n• हमारी टीम रिपोर्ट को जांचकर सुनिश्चित करती है कि वह सही और काम करने लायक हो।\n• ज़रूरत पड़ने पर हम स्थानीय लोगों से बात करके स्थिति अच्छी तरह समझते हैं।\n• हम मरम्मत या बहाली के लिए विक्रेताओं से वास्तविक लागत का अनुमान लेते हैं।\n• सत्यापन और लागत तय होने के बाद समस्या को फंडिंग और निष्पादन के लिए आगे बढ़ाया जाता है।",

    "about.faq.q2.question": "दान और रिफंड कैसे काम करते हैं?",
    "about.faq.q2.answer": "दान सिर्फ सत्यापित समस्याओं पर ही लिए जाते हैं, ताकि भरोसा और पारदर्शिता बनी रहे। दानकर्ता अपने रसीदें सीधे रसीद स्क्रीन से डाउनलोड कर सकते हैं।\n\nरिफंड नियम:\n• रिफंड प्रोसेस करते समय केवल वास्तविक पेमेंट गेटवे शुल्क लगाया जाता है — हमारी ओर से कोई अतिरिक्त शुल्क नहीं जोड़ा जाता।\n• जब काम चल रहा हो या पूरा हो चुका हो, तब रिफंड की अनुमति नहीं होती।\n• अगर कुल आवश्यक राशि का 80% से ज़्यादा जमा हो चुका है, तो रिफंड अनुरोध मॉडरेटर की समीक्षा से गुजरते हैं ताकि चल रहे काम पर असर न पड़े।\n• अगर 12 महीने के भीतर 100% राशि नहीं जुट पाती, तो दान की पूरी राशि सभी दानकर्ताओं को वापस कर दी जाती है।",

    "about.faq.q3.question": "मैं FixOurIndia से कैसे जुड़ सकता/सकती हूँ?",
    "about.faq.q3.answer": "हम अभी सक्रिय रूप से टीम नहीं बढ़ा रहे हैं, लेकिन उत्साही नागरिकों से हमेशा जुड़ना चाहते हैं। आप अपने विवरण इस ईमेल पर साझा कर सकते हैं: abxemailid@example.com",

    "about.faq.q4.question": "मैं समस्या कैसे रिपोर्ट करूं?",
    "about.faq.q4.answer": "फिलहाल रिपोर्टिंग चुनिंदा शहरों में उपलब्ध है। उपयोगकर्ताओं के इनपुट, समुदाय की रुचि और दान गतिविधि के आधार पर धीरे-धीरे और शहरों तक विस्तार किया जाएगा।",

    "about.faq.q5.question": "आप उच्च गुणवत्ता वाली मरम्मत कैसे सुनिश्चित करते हैं?",
    "about.faq.q5.answer": "हम आधुनिक टेक्नोलॉजी, सत्यापित स्थानीय कॉन्ट्रैक्टर और पारदर्शी वर्कफ़्लो पर निर्भर करते हैं।\nहर चरण पर फोटो, अनुमान और समुदाय की प्रतिक्रिया के ज़रिए गुणवत्ता जांची जाती है।\nकाम पूरा होने के बाद हर मरम्मत कम से कम एक साल तक प्लेटफ़ॉर्म पर दिखती रहती है ताकि यह सुनिश्चित हो सके कि वह टिकाऊ है।",

    "about.faq.q6.question": "काम कैसे किया जाता है और मॉनिटर होता है?",
    "about.faq.q6.answer": "• फंड कन्फर्म होने के बाद मरम्मत की तारीख तय की जाती है।\n• काम के दौरान कॉन्ट्रैक्टर फोटो अपडेट अपलोड करते हैं।\n• काम पूरा होने के बाद 12 महीने तक मरम्मत मॉनिटर की जाती है।\n• हर महीने फोटो पोस्ट किए जाते हैं ताकि समुदाय गुणवत्ता की जांच कर सके।",

    "about.faq.q7.question": "आप कैसे सुनिश्चित करते हैं कि भ्रष्टाचार न हो?",
    "about.faq.q7.answer": "• हर समस्या पर दान शुरू होने से पहले खर्च का पूरा ब्रेकडाउन दिखाया जाता है।\n• लागत सिर्फ सत्यापित विक्रेता अनुमानों पर आधारित होती है — कुछ भी छिपा नहीं रहता।\n• कोई रिश्वत, कोई टेबल के नीचे भुगतान और कोई बिचौलिया नहीं।\n• FixOurIndia स्वीकृत वर्कफ़्लो के बाहर किसी को भुगतान नहीं करता।\n• सभी लेनदेन और अपडेट सार्वजनिक होते हैं, जिससे पूरी पारदर्शिता बनी रहती है।",

    "about.faq.q8.question": "मेरे रिफंड की राशि, दान की गई राशि से थोड़ी अलग क्यों है?",
    "about.faq.q8.answer": "FixOurIndia हमेशा अपनी ओर से पूरी रिफंड राशि जारी करता है।\n• जो भी अंतर आप देखते हैं वह केवल Razorpay के नॉन-रिफंडेबल ट्रांजैक्शन शुल्क से आता है — यह एक मानक इंडस्ट्री पॉलिसी है जिसे हम बदल नहीं सकते।\n• हम पहले से ही अंतिम रिफंड राशि स्पष्ट रूप से दिखाते हैं ताकि कोई सरप्राइज न हो।\n• हमारा वादा सरल है: पूरी ईमानदारी, कोई छुपा शुल्क नहीं और हमारी ओर से कोई चुपचाप कटौती नहीं।",

    "about.faq.q9.question": "आप किसी समस्या के लिए दान कब बंद करते हैं?",
    "about.faq.q9.answer": "जैसे ही ज़रूरत से ज़्यादा पैसा लेना गैर-ज़िम्मेदाराना या अनावश्यक हो जाता है, हम दान बंद कर देते हैं।\nहम इन परिस्थितियों में कैंपेन बंद करते हैं:\n• जब समस्या के लिए आवश्यक 100% राशि जुट जाती है।\n• जब मरम्मत शुरू हो चुकी हो और अतिरिक्त धन की ज़रूरत न हो।\n• जब समस्या अवैध हो जाए (पहले ही ठीक हो चुकी हो, अधिकारियों द्वारा रोकी गई हो, असुरक्षित हो या अप्रासंगिक हो जाए)।\n• जब एक साल तक लक्ष्य पूरा न हो और समुदाय आगे न बढ़ने का फैसला करे।\n• जब हमारी टीम को सत्यापन से जुड़ी गंभीर समस्या या दोबारा जांचने योग्य बात मिलती है।\nFixOurIndia कभी भी अनावश्यक रूप से फंडरेज़िंग खुली नहीं रखता — हम सिर्फ उतना ही लेते हैं जितना वास्तव में मरम्मत पूरी करने के लिए ज़रूरी है।"

    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
